module.exports = __webpack_public_path__ + "img/example-import.536fdf7c.svg";